module.exports = __webpack_public_path__ + "static/media/goodreads.a0a2e807.svg";